import { ErrorInfo } from "@/types/error"

import webfileApi from "@/services/api/api_webfiles"
import { utils } from "@/mixins/utils"

/**
 * Converts an unknown thing to an ErrorInfo object.
 * If the input is a string, it creates an ErrorInfo object with the error property set to the string value.
 * If the input is an instance of the Error class, it creates an ErrorInfo object with the error property set to the error message.
 * If the input has an error, then it will return it as-is, otherwise it will return the value as the error in a new ErrorInfo
 * @param err The unknown value.
 * @returns The converted ErrorInfo object or the input value.
 */
export function convertToErrorInfo (err: any): ErrorInfo | any {
	if (typeof err === "string") {
		return { error: err, source: null }
	}

	if (err && err.error && err.source) {
		return err
	}

	if (err && !err.error) {
		return { error: err, source: null }
	}

	if (err instanceof Error) {
		return { error: err.message, source: null }
	}
	return err
}

export async function loadErrorInfo (error: ErrorInfo | string | null): Promise<ErrorInfo> {
	const errorInfo = convertToErrorInfo(error)
	if (errorInfo?.source) {
		return errorInfo
	}

	const online = await utils.methods.isOnline()

	if (!online) {
		return {
			error: "Unable to connect.</br> Please check your network connection.",
			isHtml: true
		}
	}

	try {
		const errorMessage = await webfileApi.serviceError()
		return {
			error: errorMessage || "Unable to establish a connection to data service.",
			isHtml: !!errorMessage
		}
	} catch {
		return {
			error: "Unable to establish a connection to data service."
		}
	}
}
